module.exports = __webpack_public_path__ + "static/retail-blog-img-2-19547b76c75d4fcc0fdefda178473c4e.jpg";